import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import "@fontsource/playfair-display";
import "@fontsource/source-sans-3";
import "./App.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
  enabled: import.meta.env.PROD,
  sendDefaultPii: true,
  enableLogs: true,
  beforeSend: (event) => {
    return event;
  },
});

/* eslint-disable no-console */
if (import.meta.env.DEV) {
  console.log(
    "%c✨ Welcome to Daniella Bianchi's dev environment! ✨",
    "color: #C7A230; font-size: 16px; font-weight: bold;"
  );
  console.log(
    "%c🔧 Built with React, TypeScript, Vite, Tailwind, and Sentry",
    "color: #888; font-size: 12px;"
  );
} else {
  console.log(
    "%c✨ Thanks for visiting Daniella Bianchi's site! ✨",
    "color: #C7A230; font-size: 16px; font-weight: bold;"
  );
  console.log("%c💻 Developer | 📚 Author | 🌍 Solo Traveller ", "color: #888; font-size: 12px;");
  console.log(
    "%c🛠️ Built with React, TypeScript, Vite, Tailwind, and Sentry",
    "color: #555; font-size: 11px;"
  );
  console.log(
    "%c🚀 Deployed on Netlify • 📖 418 days, 6 continents, 1 woman",
    "color: #555; font-size: 11px; font-style: italic;"
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
